import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";
import CardVisiMisi from "../../../components/user/visi-misi/CardVisiMisi";

function VisiMisi() {
	return (
		<PublicLayout
			title="Visi & Misi"
			subtitle="Visi dan misi Jogja Madrasah Digital"
		>
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[68%]">
					<CardVisiMisi />
				</div>
				<div className="w-full lg:w-[30%]">
					<BeritaPopuler />
				</div>
			</div>
		</PublicLayout>
	);
}

export default VisiMisi;
